import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import api from '../api/marksEntry';
import loginapi from '../api/login';
import SelectedImages from '../components/SelectedImages'
import { APISERVERURL } from '../APIServerURL';

function UploadNewBatch({accessToken,setAccessToken,setRefreshFailed  }) {
  const navigate = useNavigate();
    const [programName, setProgramName] = useState("");
     const [nameError, setNameError] = useState("Programme name is required");
    const [images,setImages]=useState([]);
    const [uploadStatus, setUploadStatus]=useState(null);
const [isUploading,setIsUploading]=useState(false);

  const handleGoBack = () => {
    navigate(`/`); 
  };


  const handleAddNew=async (e)=>
      {
         e.preventDefault();
         setUploadStatus(null);
         setIsUploading(true);
         
          let formData = new FormData();    //formdata object
          formData.append("program", programName);
    
          
    
          Object.values(images).forEach(file=>{
            formData.append("images", file);
          });
          const config = {     
              headers: { 'content-type': 'multipart/form-data' }
          }
    
        
         //call api to save the form  

         
          try{
          const response= await api.post('/uploadBatchFile',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
          //setRegistrationForm(response.data.registrationForm);
          //alert(JSON.stringify(response.data));
           setUploadStatus(response.data.result);
           updateProgrammeNameByVal("");
          setImages([]);
          }
          catch(err)
          {
              try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              //alert(JSON.stringify(x['data']['accessToken']));
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              //console.log(`ne at ${nat}`);
              //console.log(`Second at:${accessToken}`);
              try{       
                  const response= await api.post('/uploadBatchFile',formData,{headers:{'Authorization':`Bearer ${nat}`}});      
                 // setRegistrationForm(response.data.registrationForm); 
                     //alert(JSON.stringify(response.data));
                     setUploadStatus(response.data.result);
                      updateProgrammeNameByVal("");
                  setImages([]);
              }
              catch(err)
              {
                  alert('unusual error newposts.js');
                 
                  //navigate('/');
              }
              }
              catch(err)
              {
              alert('failed');
             
              //setError(JSON.stringify(err));
              //navigate('/');
              }

          }
          finally
          {
             setIsUploading(false);
          }
        }


  function addToImageList(selectedFiles)
  {
      const newImages=[...images,...selectedFiles];
      setImages(newImages);
        setUploadStatus(null);
  }
  function updateProgrammeName(e)
  {
       setProgramName(e.target.value);
       if(e.target.value.trim()==="")
       {
        setNameError("Programme name is required");
       }
       else{
        setNameError("");
       }
  setUploadStatus(null);

  }
  function updateProgrammeNameByVal(v)
  {
       setProgramName(v.trim());
       if(v.trim()==="")
       {
        setNameError("Programme name is required");
       }
       else{
        setNameError("");
       }
  }

  return (
     <main className="w-full">
         <div className="flex flex-col items-center w-full">

 
         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> UPLOAD NEW BATCH FILE</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(...)</p>    
          </div>

        
        <form className='w-[98%] max-w-[600px] ' onSubmit={handleAddNew}>
        <div className="flex flex-col items-center justify-center  w-full mt-3">
          <div className="flex flex-col justify-center items-center w-full  max-w-[600px] w-[99%] mb-2">
            <label className="self-start">Programme name:</label>
            <input
        type="text"
        value={programName}
        onChange={(e) => updateProgrammeName(e)}
        className="border p-2 rounded w-full p-3  mt-2 mb-2"
        placeholder="Eg. UG-Science UG-Arts PG-Zoology...."
      />
          </div>
           <div className="flex flex-col justify-center items-start w-full  max-w-[600px] w-[99%] mb-2">
          <label
  htmlFor="fuPhotos"
  className="inline-block px-4 py-2 bg-blue-600 text-white rounded cursor-pointer hover:bg-blue-700 transition"
>
  Select CSV to Upload
</label>
<input
  type="file"
  id="fuPhotos"
  name="uploadedPhotos"
  accept=".csv"
  style={{ display: 'none' }}
  onClick={(e) => {
    e.target.value = null; // 👈 reset input so same file can be selected again
  }}
  onChange={(e) => {
    addToImageList(e.target.files);
  }}
/>
<p className="mt-1">Please note, the CSV should be in the following format:</p>
<p className="bg-yellow-200">Sl.No.,	NAME OF THE APPLICANT,	NAME OF FATHER,	NAME OF MOTHER,	Instion Name,	Registration NO</p>
<p>in the same order.</p>
</div>

           <div className="max-w-[600px] w-[99%] p-3  mt-2 mb-2">
            <SelectedImages
            images={images}
            setImages={setImages}
            >
            </SelectedImages>
            </div>

{uploadStatus===null && (<div className="flex flex-col justify-center items-center w-full  max-w-[600px] w-[99%] mb-2 mt-2 p-2">
<p className="text-red-800">
  {nameError}
</p>
{images.length === 0 && (
  <p className="text-red-800">
    CSV file is required
  </p>
)}
</div>)}

   <div className="flex flex-col justify-center items-center w-full max-w-[600px] w-[99%] mb-2 mt-2 p-2">
      <button
          type="submit"
          className="inline-block px-4 py-2 bg-green-600 text-white rounded cursor-pointer hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={isUploading || nameError !== "" || images.length === 0}
         >
          {isUploading ? "PLEASE WAIT..." : "UPLOAD"}
    </button>

    {uploadStatus!=null &&(<div className="p-2">
      <p className="text-center font-bold">DONE</p>
      <p>{`Success Count:${uploadStatus.successCount}`}</p>
       <p>{`Duplicate Count:${uploadStatus.dupCount}`}</p>
        <p>{`Error Count:${uploadStatus.errorCount}`}</p>
    </div>)}
</div>          
        </div>
      </form>
      </div>
    </main>
  );
}

export default UploadNewBatch;
